module.exports = __webpack_public_path__ + "img/document.e72e492.svg";